import React from "react";

interface QuoteRecipientAmountProps {
  customerName: string;
  totalAmount: number;
  totalAmountKorean: string;
}

export function QuoteRecipientAmount({
  customerName,
  totalAmount,
  totalAmountKorean,
}: QuoteRecipientAmountProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-end gap-4 sm:gap-6 mb-6 sm:mb-8">
      <div className="border-b-2 border-gray-800 pb-1 pr-2 sm:pr-4 min-w-[180px] sm:min-w-[200px] overflow-hidden">
        <span className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-800 mr-2">
          {customerName}
        </span>
        <span className="text-base sm:text-lg md:text-xl font-normal text-gray-600">
          귀중
        </span>
      </div>
      <div className="text-left sm:text-right">
        <div className="flex flex-col sm:flex-row sm:items-baseline gap-1 sm:gap-0">
          <span className="text-gray-600 text-sm sm:text-sm md:text-base sm:mr-4 font-semibold">
            합계금액 :
          </span>
          <div>
            <span className="text-base sm:text-lg md:text-2xl font-semibold text-gray-900">
              일금 {totalAmountKorean} 원정
            </span>
            <span className="text-sm sm:text-base md:text-lg text-gray-500 ml-2">
              (₩{totalAmount.toLocaleString("ko-KR")})
            </span>
          </div>
        </div>
        <div className="text-2xs sm:text-2xs md:text-xs text-gray-400 mt-1">
          (부가가치세 포함)
        </div>
      </div>
    </div>
  );
}
